import React, { useState, useEffect } from 'react';
import { translations } from './translations';

const LANG_CODE_MAP = {
	en: 'english',
	hi: 'hindi',
	bn: 'bengali',
	be: 'bengali',
	gu: 'gujarati',
	kn: 'kannada',
	ml: 'malayalam',
	mr: 'marathi',
	ma: 'marathi',
	or: 'oriya',
	pa: 'punjabi',
	pu: 'punjabi',
	as: 'assamese',
	ta: 'tamil',
	te: 'telugu',
};

const getLangFromQuery = () => {
	const params = new URLSearchParams(window.location.search);
	const code = params.get('languageCode');
	return LANG_CODE_MAP[code] && translations[LANG_CODE_MAP[code]]
		? LANG_CODE_MAP[code]
		: 'english';
};

const Termscondition = () => {
	const [selectedLanguage, setSelectedLanguage] = useState(getLangFromQuery);
	const [termsContent, setTermsContent] = useState(() => translations[getLangFromQuery()]);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		setTermsContent(translations[selectedLanguage]);
	}, [selectedLanguage]);

	const handleLanguageChange = (e) => {
		setSelectedLanguage(e.target.value);
	};

	return (
		<div className="container mx-auto px-4 py-8">
			<div className="flex justify-between items-center mb-6">
				<div className="flex items-center">
					<label htmlFor="language-select" className="mr-2 text-gray-700">
						Language:
					</label>
					<select
						id="language-select"
						value={selectedLanguage}
						onChange={handleLanguageChange}
						className="rounded p-1"
					>
						<option value="english">English</option>
						<option value="tamil">தமிழ்</option>
						<option value="telugu">తెలుగు</option>
						<option value="hindi">हिन्दी</option>
						<option value="kannada">ಕನ್ನಡ</option>
						<option value="malayalam">മലയാളം</option>
						<option value="marathi">मराठी</option>
						<option value="punjabi">ਪੰਜਾਬੀ</option>
						<option value="assamese">অসমীয়া</option>
						<option value="bengali">বাংলা</option>
						<option value="gujarati">ગુજરાતી</option>
						<option value="oriya">ଓଡ଼ିଆ</option>
					</select>
				</div>
			</div>
			{/* <p className="text-sm text-gray-500 mb-8">{termsContent.updatedDate}</p> */}
			<div
				className="prose max-w-none"
				dangerouslySetInnerHTML={{ __html: termsContent.content }}
			/>
		</div>
	);
};

export default Termscondition;
